var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showPartial
    ? _c("div", { staticClass: "main-nav grid", class: [_vm.bemFacet] }, [
        _vm.facet === "mobile"
          ? _c("button", {
              staticClass: "u-reset main-nav--mobile-backdrop",
              attrs: { type: "button", "aria-hidden": "true" },
              on: { click: _vm.onRequestCloseMobileNavigation }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "main-nav--list" }, [
          _c(
            "ul",
            { staticClass: "u-reset main-nav--items", class: _vm.itemsClasses },
            _vm._l(_vm.partial.content.menu, function(entry, entryIdx) {
              return _c(
                "li",
                { key: entryIdx, staticClass: "main-nav--item" },
                [
                  _c(
                    "router-link",
                    {
                      ref: "entries",
                      refInFor: true,
                      staticClass: "u-reset main-nav--link",
                      attrs: {
                        "exact-active-class": _vm.bemAdd(
                          "is-active-exact",
                          "link"
                        ),
                        "active-class": _vm.bemAdd("is-active", "link"),
                        to: entry.path
                      }
                    },
                    [
                      _c("span", {
                        staticClass: "main-nav--link-label",
                        domProps: { textContent: _vm._s(entry.label) }
                      })
                    ]
                  )
                ],
                1
              )
            })
          )
        ]),
        _vm._v(" "),
        _vm.hasRail && _vm.isMounted
          ? _c("div", { staticClass: "main-nav--wave", style: _vm.railStyles })
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8f873206", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f873206","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/main-nav/index.vue
// module id = 368
// module chunks = 5